import OnboardingStep from '$/_const/OnboardingStep.ts';
import Routes from '@/router/Routes.ts';

export const onboardingRouteFor = (step: string | null | undefined): string => {
  if (!step) {
    return Routes.ONBOARDING__START;
  }

  if (step === OnboardingStep.PREFERRED_NAME) {
    return Routes.PREFERRED_NAME;
  }

  if (step === OnboardingStep.DNA_CONFIRMATION) {
    return Routes.ONBOARDING__DNA_CONFIRMATION;
  }

  if (step === OnboardingStep.TRIP_CREATION) {
    return Routes.ONBOARDING__TRIP_CREATE;
  }

  if (step.startsWith('dna_')) {
    return Routes.ONBOARDING__DNA;
  }

  return Routes.ONBOARDING__START;
};

export const canConfirmTrip = (step: string | null | undefined): boolean =>
  step === OnboardingStep.FINISHED || step === OnboardingStep.TRIP_CREATION;
